import { runDemo } from "../shared/demoRunner";
import { createBoomScene } from "./scene";

runDemo({
    createScene: createBoomScene,
});
